import { ApiError } from '@/api/ApiError'
import { useGetMe } from '@/generated/http-clients/backofficeApiComponents'
import { Text } from '@chakra-ui/react'
import { Header } from '@hivemq/ui-library'

function errorText(error: unknown) {
  if (error instanceof ApiError) {
    return `Unavailable (HTTP ${error.status})`
  }
  if (error instanceof Error) {
    return `Unavailable (${error.message})`
  }
  return 'Unavailable'
}

export function StaffIdentityDetails() {
  const { data, error, isPending } = useGetMe({})

  return (
    <Header.MenuContentDetails fontSize="xs">
      {isPending && <Text>Loading…</Text>}
      {error && <Text color="fg.error">{errorText(error)}</Text>}
      {data && <Text>{data.email ?? 'No email'}</Text>}
    </Header.MenuContentDetails>
  )
}
